import {Button as ButtonPrimitive} from "@base-ui/react/button"
import {type VariantProps} from "class-variance-authority"

import {cn} from "@/lib/utils"
import buttonVariants from "@/components/ui/variants/buttonVariants.ts";
import {LoaderIcon} from "lucide-react";


function Button({
                    className,
                    children,
                    disabled,
                    variant = "default",
                    size = "default",
                    loading = false,
                    ...props
                }: ButtonPrimitive.Props & VariantProps<typeof buttonVariants> & { loading?: boolean }) {
    return (
        <ButtonPrimitive data-slot="button" className={cn(buttonVariants({variant, size, className}))} children={<>
            {loading ? (
                <LoaderIcon className="animate-spin text-current"/>
            ) : children}
        </>} disabled={disabled || loading} {...props}
        />
    )
}

export {Button}
